export default __webpack_public_path__ + "static/media/Raion1.86fa91c0.png";